app.service('sticky',function(html){
	var $self=false;
	var ticking=false, saveHeight = 0, breakpointHeight = 600;

	function scroll(scrollPosition) {
		if(scrollPosition > breakpointHeight) {
			html.add('sticky');
		} else {
			html.remove('sticky');
		}
	}
	function setElements(){
		
	}
	function setEvents(){
		
		$(window).on('scroll',function(){
			saveHeight = $(window).scrollTop();
			if (!ticking) {
				requestAnimationFrame(function(){
					scroll(saveHeight);
					ticking = false;
				});
			}
			ticking = true;
		});
	}
	function init() {
		setElements();
		setEvents();
		scroll();
	}
	return {
		init:init
	};
});